import moment from "moment-business-days";

const daysToPay = 1; //working days to pay orders via boleto
const textDaysToPay = "um"; //working days to pay orders via boleto in full

function canPayViaBoleto(type, day) {
  if (type === "cycles") return true;

  const today = moment().format("Y-MM-DD");
  const lastValidDay = moment(day)
    .businessSubtract(daysToPay)
    .format("Y-MM-DD");

  return today < lastValidDay;
}

function labelDaysToPay() {
  return (
    textDaysToPay + ` (${daysToPay}) ` + (daysToPay === 1 ? "dia" : "dias")
  );
}

function firstDayToPayViaBoleto(formatDate = "DD/MM") {
  return moment()
    .businessAdd(daysToPay + 1)
    .format(formatDate);
}

export default {
  canPayViaBoleto,
  labelDaysToPay,
  firstDayToPayViaBoleto
};



// WEBPACK FOOTER //
// ./src/utils/validators/payments.js